import { StoreMapper } from "./types"

export const defaultMapper: StoreMapper<any, any> = (value) => value
